import { BaseApi } from '@smorder/logic';

class NoteApi extends BaseApi {
  createNote(note) {
    return this.authorizedFetch('/api/v1/Notes/',
      {
        method: 'POST',
        body: JSON.stringify(note),
      });
  }

  loadNotes(dto) {
    return this.authorizedFetch(`/api/v1/Notes/?${this.toQueryString(dto)}`);
  }

  deleteNote(note) {
    return this.authorizedFetch(`/api/v1/Notes/${note.id}`,
      {
        method: 'DELETE',
        parseAsText: true,
      });
  }
}

export default NoteApi;
